// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"729":"d57e54346bd440fc","766":"815464b6b6d214a6"}[chunkId] + ".js";
};